import React from 'react';
import styled, { keyframes, withTheme } from 'styled-components';
import loader from 'granite-admin/core/components/Animations/dotloader';
import PropTypes from 'prop-types';
const loadingAnimation = keyframes`${loader}`;
const StyledDiv1 = styled.div`
  opacity: 0;
  animation: ${loadingAnimation} 0.6s infinite;
  animation-delay: 0s;
  font-size: ${({
  size
}) => size || '30px'};
  font-weight: bold;
`;
const StyledDiv2 = styled.div`
  opacity: 0;
  animation: ${loadingAnimation} 0.6s infinite;
  animation-delay: 0.2s;
  font-size: ${({
  size
}) => size || '30px'};
  font-weight: bold;
`;
const StyledDiv3 = styled.div`
  opacity: 0;
  animation: ${loadingAnimation} 0.6s infinite;
  animation-delay: 0.4s;
  font-size: ${({
  size
}) => size || '30px'};
  font-weight: bold;
`;
const Loader = ({
  color,
  size,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, "Loading", /*#__PURE__*/React.createElement(StyledDiv1, {
    size: size
  }, "."), /*#__PURE__*/React.createElement(StyledDiv2, {
    size: size
  }, "."), /*#__PURE__*/React.createElement(StyledDiv3, {
    size: size
  }, "."));
};
Loader.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string
};
export default withTheme(Loader);